import * as swal from "sweetalert";
import {CategoryService} from "../../../account/core/services/CategoryService"
export class FeedbackPageComponent implements ng.IComponentOptions {
  public controller: any = FeedbackController;
  public template: string =
  `
  <div class="container container-fluid padding-2">
    <breadcrumb tree="$ctrl.tree"></breadcrumb>
    <div class="card row margin-bottom">
      <div class="card-header padding b-bottom">
        <h4>Feedback Form</h4>
      </div>
      <div class="part-100 padding">
          <form class="form-horizontal">
          <div class="form-group part margin-0">
            <label for="title" class="part-20 control-label" style="line-height:40px">Type</label>
            <div class="part-80">
            <ui-select ng-model="$ctrl.form.type" required name="ministry">
              <ui-select-match placeholder="Select Feedback Type">
                <span ng-bind="$select.selected.name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item in ($ctrl.feedbackTypes | filter: $select.search)">
                <span ng-bind="item.name"></span>
              </ui-select-choices>
            </ui-select>
            </div>
          </div>
          <div class="form-group part margin-0">
            <label for="title" class="part-20 control-label" style="line-height:40px">Source of Data (if relevant)</label>
            <div class="part-80">
              <input type="text" class="form-control" id="title" placeholder="Source of Data" ng-model="$ctrl.form.source">
            </div>
          </div>
          <div class="form-group part margin-0">
            <label for="title" class="part-20 control-label" style="line-height:40px">Title</label>
            <div class="part-80">
              <input type="text" class="form-control" id="title" placeholder="Title" ng-model="$ctrl.form.title">
            </div>
          </div>
          <div class="form-group part margin-0">
            <label for="content" class="part-20 control-label" style="line-height:40px">Details</label>
            <div class="part-80">
              <textarea class="form-control" id="content" placeholder="Details" rows="10" ng-model="$ctrl.form.content"></textarea>
            </div>
          </div>
          </form>
      </div>
      <div class="card-footer padding b-top text-center">
        <button class="btn btn-warning" ng-click="$ctrl.reset()">Reset</button>
        <button class="btn btn-primary" ng-click="$ctrl.submit()" ng-disabled="$ctrl.submitting"><i class="fa fa-fw fa-spin fa-spinner" ng-show="$ctrl.submitting"></i>Submit</button>
      </div>
    </div>
  <div>
  `
  ;
}

export class FeedbackController {
  public static $inject: Array<string> = ['$http', "CategoryService", "$window", "$anchorScroll"]
  public tree: Array<any>;
  public form: any;
  public submitting: boolean;
  public feedbackTypes: Array<any>;
  constructor(private $http: ng.IHttpService, private category: CategoryService, private $window: ng.IWindowService, private $anchorScroll: ng.IAnchorScrollService) {
    this.tree = [
      {name: "Feedback", path: "#/feedback"}
    ];
    category.query("feedbacktype").then((d:any) => {
      this.feedbackTypes = d;
    })
  }
  public $onInit() {
    this.$anchorScroll();
  }
  public reset() {
    this.form = {};
  }
  public submit() {
    this.submitting = true;
    this.$http.post(`${BASE}/api/feedback`, this.form)
    .then(() => {
      this.submitting = false;
      this.reset();
      swal({
        type: "success",
        title: "Thank you",
        text: "Your Feedback has been submitted"
      }, () => {
        this.$window.open("#/search","_top");
      });
    })
    .catch(() => {
      this.submitting = false;
      swal("Sorry", "Your Feedback is failed to submit, please try it again later", 'warning');
    })
  }
}
